import * as React from "react"
import { fromJSX, IOWidget, Updater } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { getLangFromUrl } from "../../../utils/history.mod"

// TODO is this block used?

export type jobAlertBlockProps = {
  block_index: number
  collapsed_status: "no_collapse" | "collapse_open" | "collapse_closed"
}

export type jobAlertBlockStyle = {}

export const jobAlertsBlock : (props: jobAlertBlockProps, options?: { style: jobAlertBlockStyle; key?: string }) => (s: CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> = 
  (props: jobAlertBlockProps, options?: { style: jobAlertBlockStyle; key?: string }) =>  
  (s: CMSState) => (public_state: PublicSiteState) => {
    let link = getLangFromUrl() == "en"
      ? "https://ssl1.peoplexs.com/Peoplexs22/Newsletterportal/NewsletterForm.cfm?PortalID=15720&NewsletterID=928&PortalID=15720"
      : "https://ssl1.peoplexs.com/Peoplexs22/Newsletterportal/NewsletterForm.cfm?PortalID=15720&NewsletterID=921&PortalID=15720"

    return fromJSX(
      setState => (
        <section className="block block--form block--job">
          <div className="block__inner ls-container">
            <div className={`block__wrap expander expander--${props.collapsed_status == "collapse_open" ? "open" : "closed"}`}>
              <header className='expander__header'>
                <h2 className='expander__title title--m'>Job Alerts</h2>
                {props.collapsed_status != "no_collapse" ?
                  <button
                    onClick={_ => {
                      setState(s => {
                        let currentBlock = s.blocks.get(props.block_index) as any
                        if (currentBlock == undefined) return s
                        if (currentBlock.kind === 'jobAlertBlock') {
                          currentBlock = {
                            ...currentBlock,
                            value: [
                              { ...currentBlock.value[0], collapsed_status: currentBlock.value[0].collapsed_status == "collapse_open" ? "collapse_closed" as "collapse_closed" : "collapse_open" as "collapse_open" },
                              currentBlock.value[1]
                            ]
                          }
                        }
                        return { ...s, blocks: s.blocks.set(props.block_index, currentBlock) }
                      })
                    }}
                    className={`link`}>
                    {props.collapsed_status == "collapse_open" ?
                      "Collapse job alert form" :
                      "Sign up for job alert"}
                  </button>
                  : null
                }
              </header>
              {
                props.collapsed_status == "no_collapse" || props.collapsed_status == "collapse_open" ?
                  <div className="block__content">
                    <iframe className='block__iframe' style={{width: '100%', minHeight: '1490px', border: 'none'}}  src={link} />
                  </div> : null
              }
            </div>
          </div>
        </section>
      )
    )
  }